var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_OUTSOURCED_ORDERS_BY_STORE = 'api/store/:storeId/outsourced-orders';
const GET_OUTSOURCED_ORDERS_BY_ORDER = 'api/orders/:orderId/outsourced-orders';
const GET_SET_OUTSOURCED_ORDERS = 'api/outsourced-orders';
export const getOutsourcedOrdersByOrder = function (orderId_1) {
    return __awaiter(this, arguments, void 0, function* (orderId, params = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'partnerId',
                'statuses',
            ], params);
            const querySuffix = queryParams ? `?${queryParams}` : '';
            return yield this.axiosInstance.get(`${GET_OUTSOURCED_ORDERS_BY_ORDER.replace(':orderId', orderId)}${querySuffix}`, config);
        }
        catch (error) {
            console.error('Error fetching getOutsourcedOrdersByOrder:', error);
            throw error;
        }
    });
};
export const getOutsourcedOrdersByStore = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'statuses',
                'page',
                'limit',
                'sequence',
                'partnerId',
                'dateFrom',
                'dateTo',
                'dateField',
                'includeSummary',
                'sortBy',
                'sortDirection'
            ], params);
            return yield this.axiosInstance.get(`${GET_OUTSOURCED_ORDERS_BY_STORE.replace(':storeId', params.storeId)}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getOutsourcedOrdersByStore:', error);
            throw error;
        }
    });
};
export const getOutsourcedOrderById = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_OUTSOURCED_ORDERS}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching getOutsourcedOrderById:', error);
            throw error;
        }
    });
};
